import React, { useContext, useState, useEffect } from 'react';
import {
	ICustomerFullInfoContext,
	CustomerFullInfoContext,
} from '../../../../../../../../customerFullInfoState/customerFullInfoContext';
import Button from 'components/Button/Button';
import Text from 'components/Text/Text';
import LanguageBar from './components/LanguageBar/LanguageBar';
import Items from './components/Items';
import breadcrumbs from 'assets/img/breadcrumbs.svg';
import classNames from 'classnames';
import style from './Tags.module.scss';

const Tags: React.FC = () => {
	const { customerForFullInfo } = useContext<ICustomerFullInfoContext>(CustomerFullInfoContext);
	const [selectedLanguage, setSelectedLanguage] = useState<Nullable<string>>(null);
	const [isShowAdditionalTags, setIsShowAdditionalTags] = useState(false);
	const iconNextClasses = classNames(style.iconNext, { [style.rotate]: isShowAdditionalTags });

	const handleClick = () => {
		setIsShowAdditionalTags(!isShowAdditionalTags);
	};

	useEffect(() => {
		customerForFullInfo?.defaultLanguageId && setSelectedLanguage(customerForFullInfo.defaultLanguageId);
	}, [customerForFullInfo?.defaultLanguageId]);

	return (
		<div className={style.container}>
			<div className={style.controlsWrapper}>
				<LanguageBar
					setSelectedLanguage={setSelectedLanguage}
					selectedLanguage={selectedLanguage}
					tags={customerForFullInfo?.tags || []}
					IDCustomerDefaultLanguage={customerForFullInfo?.defaultLanguageId || ''}
				/>
				<Button
					theme="secondaryPurple"
					onClick={handleClick}
					className={style.button}
					disabled={customerForFullInfo?.tags.length ? customerForFullInfo?.tags[0].tags.length < 4 : true}
					icon={
						<svg className={iconNextClasses}>
							<use xlinkHref={`${breadcrumbs}#rightAngleArrow`} />
						</svg>
					}>
					<Text
						translationNameSpace="form"
						translationKey={isShowAdditionalTags ? 'hideBlockButton' : 'expandBlockButton'}
						asFragment={true}
					/>
				</Button>
			</div>
			{customerForFullInfo?.tags.map((el) => (
				<Items
					tag={el}
					isShowItems={el.languageId === selectedLanguage}
					isShowAdditionalTags={isShowAdditionalTags}
					key={el.languageId}
				/>
			))}
		</div>
	);
};

export default React.memo(Tags);
